module.exports = __webpack_public_path__ + "assets/img/35c6b7d4304de4e30903b502c13bc5d1.svg";